<!-- <ng-progress #progressBar id="progressBar" spinnerPosition="left"></ng-progress> -->
<ng-container *ngIf="isProgressing">
    <!-- <ng-progress #progressBar id="progressBar" spinnerPosition="left"></ng-progress> -->
    <mat-progress-bar mode="indeterminate" [color]="'warn'"></mat-progress-bar>
</ng-container>
<app-session-timer></app-session-timer>
<div class="backdrop"></div>
<ngx-loading [show]="isBusy" [config]="loaderConfig" class="page-loading"></ngx-loading>
<app-header></app-header>
<toaster-container [toasterconfig]="config"></toaster-container>
<div class="body-content" [class.default]="isDefault" [class.hasBackground]="hasBackground">
    <!-- <p (click)="changeColour()">Change Colour</p> -->
    <div class="body-wrapper">
        <router-outlet></router-outlet>
    </div>
    <!-- <app-floating-tabs (activeTabs)="activeTabs($event)"></app-floating-tabs> -->
    <div class="side-nav" [@slider]="slideIn ? 'open' : 'closed'">
        <!-- <ng-container *ngIf="slideIn"> -->
            <button type="button" class="close close-modal" [class.show]="slideIn" (click)="hide()">
                <span aria-hidden="true">&times;</span>
            </button>
            <app-detail [setComponentId]="detailId" [hideSection]="true"
            [forceRefresh]="'true'"></app-detail>
        <!-- </ng-container> -->
    </div>
    <!-- <div class="modal-backdrop fade in show" *ngIf="showBackdrop"></div> -->
</div>
<app-footer></app-footer>